import styled from 'styled-components';
import SvgInfo from '../../../others/svg_dist/Info';

export const Background = styled.div`
	width: 100%;
	height: 900px;
	background: url('/backgrounds/bg_form.jpeg') center center no-repeat;
	background-size: cover;
	position: relative;
	img {
		position: absolute;
		bottom: 0;
		left: 40px;
		width: 350px;
		height: auto;
		pointer-events: none;
	}
	@media screen and (max-width: 800px) {
		height: auto;
		padding: 40px 5px;
	}
	@media screen and (max-width: 500px) {
		img {
			left: 0;
		}
	}
`;

export const FormContainer = styled.div`
	width: 1000px;
	position: absolute;
	top: 55%;
	left: 50%;
	transform: translate(-50%, -50%);
	background-color: #ffffff43;
	padding: 5px;
	border-radius: 15px;
	padding-top: 20px;
	scroll-margin-top: 200px;
	& > .hover-popover {
		margin-bottom: -41px;
		transform: translate(20px, 5px);
		width: 35px;
	}
	@media screen and (max-width: 1000px) {
		width: 100%;
	}
	@media screen and (max-width: 800px) {
		position: relative;
		top: 0;
		left: 0;
		transform: unset;
	}
`;

export const FormContainerTopFont = styled.p`
	color: #fff;
	font-size: 26px;
	font-weight: 600;
	text-align: center;
	margin: 0;
	line-height: 1.3;
`;

export const FormContainerBottomFont = styled.p`
	color: #f0f0f0;
	text-align: center;
	margin: 0;
	font-size: 12px;
`;

export const FormInnerContainer = styled.div`
	width: 100%;
	background-color: #ffffffd7;
	border-radius: 10px;
	margin-top: 15px;
	padding: 25px 0;
`;

export const FormRow = styled.div`
	display: flex;
	width: 100%;
	flex-flow: row wrap;
	&.personal {
		& > div:nth-child(1) {
			flex: 1;
			margin-left: 30px;
		}
		& > div:nth-child(2) {
			flex: 2;
			margin: 0 6px;
		}
		& > div:nth-child(3) {
			flex: 1;
			margin-right: 30px;
		}
	}
	&.business-switch {
		margin-bottom: 20px;
		& > div:nth-child(1) {
			margin-left: 30px;
		}
	}
	&.business {
		margin-bottom: 30px;
		& > div:nth-child(1) {
			flex: 1;
			margin-left: 30px;
			margin-right: 6px;
		}
		& > div:nth-child(2) {
			flex: 1;
			margin-right: 30px;
		}
	}
	&.adress {
		& > div:nth-child(1) {
			flex: 4;
			margin-left: 30px;
			margin-right: 6px;
		}
		& > div:nth-child(2) {
			flex: 1;
			margin-right: 6px;
		}
		& > div:nth-child(3) {
			flex: 1;
			margin-right: 25px;
		}
		& > div:nth-child(4) {
			flex: 1;
			margin-right: 6px;
		}
		& > div:nth-child(5) {
			flex: 4;
			margin-right: 30px;
		}
	}
	&.contact {
		width: 70%;
		& > div:nth-child(1) {
			flex: 15;
			margin-left: 30px;
			margin-right: 25px;
		}
		& > div:nth-child(1) {
			flex: 10;
		}
	}
	&.nationality {
		& > div:nth-child(1) {
			margin-top: 18px;
			flex: 10;
			margin-left: 40px;
		}
		& > div:nth-child(2) {
			flex: 10;
		}
		& > div:nth-child(3) {
			flex: 15;
			margin-right: 30px;
			/* label */
			& > div:nth-child(1) {
				height: auto;
				font-size: 9px;
				margin-bottom: 2px;
				margin-top: 2px;
				margin-left: 14px;
			}
			& > div:nth-child(2) > div > div {
				margin: 0;
			}
			& > div:nth-child(2) > div > div {
				height: 40px;
			}
			& > div:nth-child(2) > div > div > div > div {
				border: 2px solid #dfdfdf;
				border-radius: 5px;
				background-color: #fff;
			}
		}
	}
	@media screen and (max-width: 800px) {
		flex-flow: column nowrap;
		& > div {
			flex: unset !important;
			margin: 0 10px !important;
		}
	}
`;

export const VerticalDivider = styled.div`
	width: 1px;
	background-color: #ccc;
	margin: 0 15px;
	height: 30px;
	margin-top: 28px;
`;

export const RowDivider = styled.div`
	width: 97%;
	margin: 20px auto;
	height: 1px;
	background-color: #ccc;
`;

export const RowHeadingFont = styled.p`
	margin: 0;
	margin-left: 30px;
	line-height: 1;
	margin-bottom: 16px;
	color: #4d4d4d;
	@media screen and (max-width: 600px) {
		margin-right: 40px;
	}
`;

export const RowExpand = styled.div<{ expanded: boolean }>`
	width: 100%;
	position: relative;
	user-select: none;
	cursor: pointer;
	margin: -10px 0;
	padding-top: 11px;
	padding-bottom: 1px;
	${({ expanded }) =>
		expanded &&
		`
        margin-bottom: 10px;
    `}
	span {
		font-size: 13px;
		color: #767676;
	}
	& > div {
		position: absolute;
		top: 0;
		right: 30px;
		transition: rotate 200ms linear;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 40px;
		height: 40px;
		${({ expanded }) =>
			expanded &&
			`
            rotate: 180deg;
        `}
	}
	svg {
		fill: #777777;
	}
	@media screen and (max-width: 600px) {
		& > div {
			right: 10px;
		}
	}
`;

export const CheckboxLabel = (
	<span>
		Jestem <strong style={{ color: '#1a1a1a' }}>cudzoziemcem</strong>
	</span>
);

export const StyledSvgInfo = styled(SvgInfo)`
	width: 35px;
	height: 35px;
	fill: #d66464;
`;

export const HasBusinessContainer = styled.div`
	display: flex;
	align-items: center;
	padding-top: 18px;
	& > p {
		margin: 0;
		margin-right: 16px;
		margin-left: 4px;
		font-weight: 600;
		color: #3f3f3f;
	}
	& > div {
		margin: 0 8px;
	}
`;
